export default __webpack_public_path__ + "static/modularfrp5-347f338d817d4b15bdd58edfc2044b1e.jpg";